import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, provideAppInitializer } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withHashLocation, withInMemoryScrolling } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { authHttpInterceptorProviders } from '@shared/interceptors/auth.interceptor';
import { environment } from '@environments/environment';
import { errorInterceptorProviders } from '@shared/interceptors/error.interceptor';
import { MessageService, ConfirmationService } from 'primeng/api';
import { initializeApp } from '@app/app-initializer';

export const appConfig: ApplicationConfig = {
    providers: [
        provideAppInitializer(initializeApp),
        MessageService,
        ConfirmationService,
        provideRouter(
            appRoutes,
            withHashLocation(),
            withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
            withEnabledBlockingInitialNavigation()
        ),
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        ...authHttpInterceptorProviders,
        ...errorInterceptorProviders,
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: environment.theme, options: { darkModeSelector: '.app-dark' } } })
    ]
};
